import { getCurrentRegion, Region } from "@/utils/environment";

export type StoreBranding = { avatar?: string; color: string };

const FALLBACK: StoreBranding = {
  color: "#929292",
};

const NA: Record<number, string> = {
  5: "#E41E31",
  10: "#ECB0C9",
  12: "#2FA9FF",
  16: "#2FA9FF",
  19: "#FADADD",
  20: "#003764",
  21: "#000000",
  23: "#E52935",
  24: "#C41230",
  26: "#24272A",
  28: "#328648",
  31: "#000E42",
  38: "#2FA9FF",
  39: "#223846",
  40: "#000000",
};
const EMEA: Record<number, string> = {
  3: "#ebe717",
  6: "#E41E31",
  8: "#ECB0C9",
  9: "#2FA9FF",
  12: "#E52935",
  15: "#E41E31",
  17: "#CC071E",
  18: "#ECB0C9",
  19: "#EAD0B7",
  20: "#D71920",
  21: "#223846",
  22: "#044E9F",
};

export const getStoreBranding = (customerId?: number, avatar?: string): StoreBranding => {
  const region = getCurrentRegion();
  const color =
    region !== Region.DEV && customerId
      ? (region === Region.EMEA ? EMEA : NA)[customerId]
      : undefined;
  return { avatar: avatar?.trim() || undefined, color: color ?? FALLBACK.color };
};
